import React, { useEffect, useState } from "react";
import { FaBars, FaLock, FaTimes } from "react-icons/fa";
import { Navigate, NavLink, Outlet, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import MinimizeArrow from "../../assets/icons/dashboard/minimize.svg";
import LogoImg from "../../assets/images/dashboard-logo.svg";
import ProfileImg from "../../assets/images/user-profile-img.svg";
import useData from "../../hooks/useData";

const DashboardLayout = () => {
  const { userData, setUserData, setAuth } = useData();
  const { profile_image, first_name, last_name } = userData;
  const [navBar, setNavbar] = useState(false);
  const [mobileNavActive, setMobileNavActive] = useState(false);
  const [navigate, setNavigate] = useState(false);
  const location = useLocation();

  const changeBackground = () => {
    if (window.scrollY >= 3) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };

  useEffect(() => {
    setMobileNavActive(false);
  }, [location]);

  useEffect(() => {
    changeBackground();
    // adding the event when scroll change background
    window.addEventListener("scroll", changeBackground);
  });

  function logoutFn() {
    const id = toast.loading("Signing out, please wait...");

    setTimeout(() => {
      toast.update(id, {
        render: "Logout Successful",
        type: "success",
        isLoading: false,
        autoClose: 1500,
      });
    }, 1500);

    setTimeout(() => {
      setUserData({});
      setAuth({});
      setNavigate(true);
    }, 3100);
  }

  if (navigate) {
    return <Navigate to="/login" replace={true} />;
  }
  return (
    <div className="dashboard container-fluid px-0">
      <div
        className={`dashboard-side-nav collapsed ${
          mobileNavActive ? "mobile-active" : ""
        }`}
      >
        <div className="dashboard-side-nav_logo_box">
          <img src={LogoImg} alt="" />
          <FaTimes
            className="d-lg-none"
            onClick={() => setMobileNavActive(false)}
            size={25}
          />
        </div>

        <div className="dashboard-side-nav_nav_list">
          <ul>
            <li>
              <p title="Coming soon">
                <span className="list__icon">
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13 19H11C8.79086 19 7 17.2091 7 15V5C7 2.79086 8.79086 1 11 1H17C19.2091 1 21 2.79086 21 5V12M1 5H4M11 5H17M11 9H17M11 13H14M15 17L16.7528 18.4023C17.1707 18.7366 17.7777 18.6826 18.1301 18.2799L21 15M2.5 19L3.2 18.0667C3.71929 17.3743 4 16.5321 4 15.6667V2.5C4 1.67157 3.32843 1 2.5 1C1.67157 1 1 1.67157 1 2.5V15.6667C1 16.5321 1.28071 17.3743 1.8 18.0667L2.5 19Z"
                      stroke="#BDBDBD"
                      strokeOpacity="0.7"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
                <span className="list__text">Dashboard</span>

                <span className="red-info">
                  <FaLock />
                </span>
              </p>
            </li>
            <li>
              <p title="Coming soon">
                <span className="list__icon">
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1 13.2824L1.76838 14.6559M1.76838 14.6559L2.53675 16.0295M1.76838 14.6559L6.20459 12.0126M17.8123 21L12.6898 12.0126L7.56734 21M15.3148 2.92145L6.44241 8.20817C5.46238 8.79212 5.1266 10.0854 5.69242 11.0969L6.71692 12.9283C7.28274 13.9397 8.53589 14.2862 9.51591 13.7023L18.3883 8.41557L15.3148 2.92145ZM20.2314 8.53824C19.4964 8.97621 18.5565 8.7163 18.1321 7.95772L15.5709 3.37929C15.1465 2.62071 15.3983 1.65072 16.1334 1.21275C16.8684 0.774784 17.8082 1.03469 18.2326 1.79327L20.7939 6.37171C21.2182 7.13029 20.9664 8.10028 20.2314 8.53824Z"
                      stroke="#BDBDBD"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
                <span className="list__text">Lessons</span>

                <span className="red-info">
                  <FaLock />
                </span>
              </p>
            </li>{" "}
            <li>
              <p title="Coming soon">
                <span className="list__icon">
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13.75 6V5.25H12.25V6H13.75ZM5.75 6V5.25H4.25V6H5.75ZM9 1L9.26334 0.297753C9.09355 0.234082 8.90645 0.234082 8.73666 0.297753L9 1ZM1 4L0.736657 3.29775C0.44393 3.40753 0.25 3.68737 0.25 4C0.25 4.31263 0.44393 4.59247 0.736657 4.70225L1 4ZM9 7L8.73666 7.70225C8.90645 7.76592 9.09355 7.76592 9.26334 7.70225L9 7ZM17 4L17.2633 4.70225C17.5561 4.59247 17.75 4.31263 17.75 4C17.75 3.68737 17.5561 3.40753 17.2633 3.29775L17 4ZM9.71103 16.0059L9.17776 15.4785V15.4785L9.71103 16.0059ZM11.2996 14.3996L11.8328 14.927L11.8328 14.927L11.2996 14.3996ZM12.238 14.1441L12.4496 13.4246L12.238 14.1441ZM6.70045 14.3996L7.23372 13.8722L6.70045 14.3996ZM8.28897 16.0059L8.82224 15.4785L8.28897 16.0059ZM5.762 14.1441L5.5504 13.4246L5.762 14.1441ZM16.25 21C16.25 21.4142 16.5858 21.75 17 21.75C17.4142 21.75 17.75 21.4142 17.75 21H16.25ZM0.25 21C0.25 21.4142 0.585786 21.75 1 21.75C1.41421 21.75 1.75 21.4142 1.75 21H0.25ZM12.25 6V8H13.75V6H12.25ZM5.75 8V6H4.25V8H5.75ZM9 11.25C7.20507 11.25 5.75 9.79493 5.75 8H4.25C4.25 10.6234 6.37665 12.75 9 12.75V11.25ZM12.25 8C12.25 9.79493 10.7949 11.25 9 11.25V12.75C11.6234 12.75 13.75 10.6234 13.75 8H12.25ZM8.73666 0.297753L0.736657 3.29775L1.26334 4.70225L9.26334 1.70225L8.73666 0.297753ZM9.26334 7.70225L17.2633 4.70225L16.7367 3.29775L8.73666 6.29775L9.26334 7.70225ZM8.73666 1.70225L16.7367 4.70225L17.2633 3.29775L9.26334 0.297753L8.73666 1.70225ZM9.26334 6.29775L1.26334 3.29775L0.736657 4.70225L8.73666 7.70225L9.26334 6.29775ZM10.2443 16.5332L11.8328 14.927L10.7663 13.8722L9.17776 15.4785L10.2443 16.5332ZM12.0264 14.8637C14.6994 15.6497 16.25 17.3265 16.25 19H17.75C17.75 16.3393 15.3869 14.2884 12.4496 13.4246L12.0264 14.8637ZM6.16718 14.927L7.7557 16.5332L8.82224 15.4785L7.23372 13.8722L6.16718 14.927ZM1.75 19C1.75 17.3265 3.30063 15.6497 5.97359 14.8637L5.5504 13.4246C2.61309 14.2884 0.25 16.3393 0.25 19H1.75ZM16.25 19V21H17.75V19H16.25ZM0.25 19V21H1.75V19H0.25ZM7.23372 13.8722C6.81027 13.444 6.17106 13.2421 5.5504 13.4246L5.97359 14.8637C6.02255 14.8493 6.09983 14.8589 6.16718 14.927L7.23372 13.8722ZM11.8328 14.927C11.9002 14.8589 11.9774 14.8493 12.0264 14.8637L12.4496 13.4246C11.8289 13.2421 11.1897 13.444 10.7663 13.8722L11.8328 14.927ZM9.17776 15.4785C9.07991 15.5774 8.92009 15.5774 8.82224 15.4785L7.7557 16.5332C8.44066 17.2259 9.55934 17.2259 10.2443 16.5332L9.17776 15.4785Z"
                      stroke="#BDBDBD"
                      strokeOpacity="0.7"
                      strokeWidth="1.5"
                    />
                  </svg>
                </span>
                <span className="list__text">CBT</span>

                <span className="red-info">
                  <FaLock />
                </span>
              </p>
            </li>{" "}
            <li>
              <p title="Coming soon">
                <span className="list__icon">
                  <svg
                    width="22"
                    height="20"
                    viewBox="0 0 22 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16.3726 6.17276C19.0986 7.39695 21 10.1611 21 13.375V16.75C21 17.9926 20.0051 19 18.7778 19H12.1111C9.2084 19 6.73898 17.1217 5.82379 14.5M16.3726 6.17276C15.6711 3.20566 13.0344 1 9.88889 1H8.77778C4.48223 1 1 4.52576 1 8.875V12.25C1 13.4926 1.99492 14.5 3.22222 14.5H5.82379M16.3726 6.17276C16.4922 6.67875 16.5556 7.20688 16.5556 7.75C16.5556 11.4779 13.5708 14.5 9.88889 14.5H5.82379"
                      stroke="#BDBDBD"
                      strokeWidth="1.5"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
                <span className="list__text">Forum</span>

                <span className="red-info">
                  <FaLock />
                </span>
              </p>
            </li>{" "}
            <li>
              <NavLink to="payments">
                <span className="list__icon">
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2 7C2 4.79086 3.79086 3 6 3H18C20.2091 3 22 4.79086 22 7V17C22 19.2091 20.2091 21 18 21H6C3.79086 21 2 19.2091 2 17V7Z"
                      stroke="#BDBDBD"
                      strokeWidth="1.5"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M2 7H22V11H2V7Z"
                      stroke="#BDBDBD"
                      strokeWidth="1.5"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M8 17H6"
                      stroke="#BDBDBD"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                    />
                  </svg>
                </span>
                <span className="list__text">Payment</span>
              </NavLink>
            </li>{" "}
            <li>
              <NavLink to="transactions">
                <span className="list__icon">
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2 7C2 4.79086 3.79086 3 6 3H18C20.2091 3 22 4.79086 22 7V17C22 19.2091 20.2091 21 18 21H6C3.79086 21 2 19.2091 2 17V7Z"
                      stroke="#BDBDBD"
                      strokeWidth="1.5"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M2 7H22V11H2V7Z"
                      stroke="#BDBDBD"
                      strokeWidth="1.5"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M8 17H6"
                      stroke="#BDBDBD"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                    />
                  </svg>
                </span>
                <span className="list__text">Transactions</span>
              </NavLink>
            </li>{" "}
            <li>
              <p title="Coming soon">
                <span className="list__icon">
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12.6831 9.08079L13.3138 9.48663L12.6831 9.08079ZM8.25 8C8.25 8.41421 8.58579 8.75 9 8.75C9.41421 8.75 9.75 8.41421 9.75 8H8.25ZM10.25 12.5C10.25 12.9142 10.5858 13.25 11 13.25C11.4142 13.25 11.75 12.9142 11.75 12.5H10.25ZM11.75 15C11.75 14.5858 11.4142 14.25 11 14.25C10.5858 14.25 10.25 14.5858 10.25 15H11.75ZM10.25 16C10.25 16.4142 10.5858 16.75 11 16.75C11.4142 16.75 11.75 16.4142 11.75 16H10.25ZM20.25 11C20.25 16.1086 16.1086 20.25 11 20.25V21.75C16.9371 21.75 21.75 16.9371 21.75 11H20.25ZM11 20.25C5.89137 20.25 1.75 16.1086 1.75 11H0.25C0.25 16.9371 5.06294 21.75 11 21.75V20.25ZM1.75 11C1.75 5.89137 5.89137 1.75 11 1.75V0.25C5.06294 0.25 0.25 5.06294 0.25 11H1.75ZM11 1.75C16.1086 1.75 20.25 5.89137 20.25 11H21.75C21.75 5.06294 16.9371 0.25 11 0.25V1.75ZM12.25 8C12.25 8.24996 12.1774 8.48068 12.0524 8.67495L13.3138 9.48663C13.5899 9.05757 13.75 8.54634 13.75 8H12.25ZM9.75 8C9.75 7.30964 10.3096 6.75 11 6.75V5.25C9.48122 5.25 8.25 6.48122 8.25 8H9.75ZM11 6.75C11.6904 6.75 12.25 7.30964 12.25 8H13.75C13.75 6.48122 12.5188 5.25 11 5.25V6.75ZM10.25 12V12.5H11.75V12H10.25ZM12.0524 8.67495C11.9265 8.87065 11.7688 9.07313 11.5836 9.30329C11.4063 9.52369 11.1979 9.77635 11.011 10.0333C10.6424 10.5398 10.25 11.2007 10.25 12H11.75C11.75 11.6947 11.9003 11.3605 12.2239 10.9158C12.383 10.697 12.558 10.4851 12.7523 10.2436C12.9387 10.0119 13.1409 9.75537 13.3138 9.48663L12.0524 8.67495ZM10.25 15V16H11.75V15H10.25Z"
                      fill="#c8cdd680"
                    />
                  </svg>
                </span>
                <span className="list__text">Support</span>

                <span className="red-info">
                  <FaLock />
                </span>
              </p>
            </li>
          </ul>

          <div className="logout__group">
            {/* <Link to="/login">
              <span className="list__icon">
                <svg
                  width="17"
                  height="21"
                  viewBox="0 0 17 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16 10L10 10M1 15.2663V5.26633M13 15.2663C13 16.3709 12.1046 17.2663 11 17.2663H7M13 5.26633C13 4.16176 12.1046 3.26633 11 3.26633H7M1.8906 17.8601L3.8906 19.1934C5.21971 20.0795 7 19.1267 7 17.5293V3.00336C7 1.40597 5.21971 0.453189 3.8906 1.33926L1.8906 2.6726C1.3342 3.04353 1 3.66799 1 4.3367V16.196C1 16.8647 1.3342 17.4891 1.8906 17.8601Z"
                    stroke="#C8CDD6"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                  />
                </svg>
              </span>
              <span className="list__text">Logout</span>
            </Link> */}

            <button onClick={logoutFn}>
              <span className="list__icon">
                <svg
                  width="17"
                  height="21"
                  viewBox="0 0 17 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16 10L10 10M1 15.2663V5.26633M13 15.2663C13 16.3709 12.1046 17.2663 11 17.2663H7M13 5.26633C13 4.16176 12.1046 3.26633 11 3.26633H7M1.8906 17.8601L3.8906 19.1934C5.21971 20.0795 7 19.1267 7 17.5293V3.00336C7 1.40597 5.21971 0.453189 3.8906 1.33926L1.8906 2.6726C1.3342 3.04353 1 3.66799 1 4.3367V16.196C1 16.8647 1.3342 17.4891 1.8906 17.8601Z"
                    stroke="#C8CDD6"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                  />
                </svg>
              </span>
              <span className="list__text">Logout</span>
            </button>
          </div>
        </div>
      </div>
      <div className="dashboard-main-content-layout">
        <div className={`top-section ${navBar ? "active" : ""}`}>
          <div className="d-flex gap-2 align-items-center top-section-info justify-content-between">
            <img
              className="d-lg-block d-none"
              src={MinimizeArrow}
              width="20"
              alt=""
            />
            <FaBars
              className="d-lg-none"
              onClick={() => setMobileNavActive(true)}
              size={20}
            />
            <div className="d-flex gap-3 user align-items-center">
              <div className="text-end d-md-block d-none">
                <h3 className="user-fullname">
                  {`${first_name} ${last_name}` || "User"}
                </h3>
                <p className="user-location">Lagos, Nigeria</p>
              </div>
              <img
                src={profile_image || ProfileImg}
                alt=""
                className="user-img"
                style={{
                  borderRadius: "50%",
                  width: `${profile_image ? "30px" : "45px"}`,
                  height: `${profile_image ? "30px" : "45px"}`,
                }}
              />
            </div>
          </div>
        </div>
        <div className="dashboard-main-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default DashboardLayout;
